import {
  ConsultantContractPensionSolution,
  ConsultantContractType,
  LegalPersonType
} from "@bonliva-crm/graphql";
import { ContractTypeUnion, ContractUnion } from "../../types";
import {
  BC_contractsTypes,
  National_contractsTypes
} from "@consultants/ConsultantContract/utils";

export const isConfirmation = (type: ContractTypeUnion) =>
  type === ConsultantContractType.ConfirmationForEmployees ||
  type === ConsultantContractType.Confirmation ||
  type === ConsultantContractType.Confirmation_National ||
  type === ConsultantContractType.ConfirmationForEmployees_National ||
  type === ConsultantContractType.BC_Framework_Confirmation ||
  type === ConsultantContractType.BC_Intermittent_Confirmation;

export const isFrameworkOrIntermittent = (type: ContractTypeUnion) =>
  type === ConsultantContractType.Intermittent ||
  type === ConsultantContractType.Intermittent_National ||
  type === ConsultantContractType.BC_Intermittent ||
  type === ConsultantContractType.BC_Framework ||
  type === ConsultantContractType.Framework ||
  type === ConsultantContractType.Framework_National;

export const salaryChoiceNotNeeded = (data: ContractUnion, is25To65: boolean) =>
  (National_contractsTypes.includes(data.Type as ConsultantContractType) &&
    (is25To65 ||
      ("pensionSolution" in data &&
        data.pensionSolution === ConsultantContractPensionSolution.Full))) ||
  isConfirmation(data.Type);

export const isSalaryChoiceError = (data: ContractUnion, is25To65: boolean) =>
  !salaryChoiceNotNeeded(data, is25To65) &&
  !("SalaryChoice" in data && data.SalaryChoice) &&
  data.IsSigned &&
  "Consultant" in data &&
  data.Consultant?.LegalPersonType === LegalPersonType.Employee &&
  !BC_contractsTypes.includes(data.Type);
